"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNTESFromHireCarEffects = exports.HireCarSchema = void 0;
const z = __importStar(require("zod"));
const serialised_eventr_date_1 = require("./serialised-eventr-date");
const start_or_end_enum_1 = require("./start-or-end-enum");
exports.HireCarSchema = z.object({
    _id: z.string(),
    pick_up: serialised_eventr_date_1.EventrDateFromStringSchema,
    drop_off: serialised_eventr_date_1.EventrDateFromStringSchema,
    passengers_list: z
        .array(z.object({
        users: z
            .array(z.object({
            option: z.union([z.string(), z.number().int()]),
        }))
            .optional(),
    }))
        .optional(),
    car_alias: z.string(),
    provider: z.string().optional(),
    pick_up_location: z.string().optional(),
    drop_off_location: z.string().optional(),
    booking_reference: z.string().optional(),
    startOrEnd: start_or_end_enum_1.StartOrEndEnum,
    check_in: serialised_eventr_date_1.EventrDateFromStringSchema.optional(),
});
/**
 * A ZodEffects that transforms the hire car data into a UNTES.
 */
exports.UNTESFromHireCarEffects = exports.HireCarSchema.transform((hireCar) => {
    return {
        id: hireCar._id,
        section: 'hire-car',
        ...(hireCar.check_in ? { checkIn: hireCar.check_in } : {}),
        date: hireCar.startOrEnd === 'start' ? hireCar.pick_up : hireCar.drop_off,
        primary: hireCar.car_alias,
        ...(hireCar.provider ? { secondary: hireCar.provider } : {}),
        ...(hireCar.booking_reference
            ? { bookingReference: hireCar.booking_reference }
            : {}),
        startOrEnd: hireCar.startOrEnd,
    };
});
